const STUDIO_DOC_TITLE = "Microsoft Azure Experimentation Studio";
const STUDIO_WIKI_URL = "https://aka.ms/exp/docs";
const STUDIO_CASE_STUDIES = "https://aka.ms/exp/docs/casestudies";
const STUDIO_RBAC_WIKI = "https://aka.ms/exp/rbac";
const STUDIO_EXPANALYSIS_WIKI = "https://expdocs.azurewebsites.net/docs/analysis/analysismanagementpage.html";
const STUDIO_ONBOARDING_URL = "https://aka.ms/exp/docs/onlinecontrolledexperimentation";
const STUDIO_WPS_WIKI = "https://eng.ms/docs/products/experimentation-platform/docs/onboarding/setuppermissions#non-msft-workspace-access-via-msft-credentials-aka-exp-for-msft-credentials";
export {
  STUDIO_CASE_STUDIES,
  STUDIO_DOC_TITLE,
  STUDIO_EXPANALYSIS_WIKI,
  STUDIO_ONBOARDING_URL,
  STUDIO_RBAC_WIKI,
  STUDIO_WIKI_URL,
  STUDIO_WPS_WIKI
};
//# sourceMappingURL=Studio.constants.js.map
